export default {
  'channelOnboarding.back': 'Back',
  'channelOnboarding.description':
    'Unified registration for commercial channel actors in a single transaction.',

  'channelOnboarding.fields.entityType': 'Registration type',
  'channelOnboarding.fields.automyPlan': 'AUTOMY plan',
  'channelOnboarding.fields.identity': 'Tax ID / Identity',
  'channelOnboarding.sections.companyData': 'Company details',
  'channelOnboarding.sections.ownerUser': 'Primary administrator',
  'channelOnboarding.fields.ownerUser.lastNames': 'Last name',
  'channelOnboarding.fields.ownerUser.invitationHint':
    'An activation invitation will be sent to the email address provided.',

  'channelOnboarding.steps.entityType.title': 'Registration type',
  'channelOnboarding.steps.entityType.hint':
    'Choose the actor type. Fields and validations change based on your selection.',
  'channelOnboarding.steps.plan.title': 'AUTOMY plan',
  'channelOnboarding.steps.plan.hint':
    'Select an active plan for the company being created. The billing subscription is created automatically.',
  'channelOnboarding.steps.company.title': 'Company',
  'channelOnboarding.steps.actor.title': 'Channel actor',
  'channelOnboarding.steps.agreement.title': 'Commercial agreement',
  'channelOnboarding.steps.agreement.hint':
    'Only approved agreements are listed. You can assign one now or leave it empty and assign later.',
  'channelOnboarding.steps.billing.title': 'Billing',
  'channelOnboarding.steps.billing.hint':
    'Optional fiscal and contact details for the billing subscription.',
  'channelOnboarding.steps.summary.title': 'Summary',

  'channelOnboarding.fields.canCreateDistributors': 'Can create distributors',

  'channelOnboarding.actions.confirmRegister': 'Confirm registration',
  'channelOnboarding.actions.registerAnother': 'Register another actor',

  'channelOnboarding.registrationSummary.title': 'Registration complete',
  'channelOnboarding.registrationSummary.subtitle':
    'The company was created successfully. Review the consolidated registration summary.',
  'channelOnboarding.registrationSummary.loadError':
    'Could not load the registration summary. Please try again.',
  'channelOnboarding.registrationSummary.sections.company': 'Company',
  'channelOnboarding.registrationSummary.sections.channelProfile': 'Commercial profile',
  'channelOnboarding.registrationSummary.sections.channelEntity': 'Channel actor',
  'channelOnboarding.registrationSummary.sections.billingSubscription': 'Billing subscription',
  'channelOnboarding.registrationSummary.sections.aiBillingProfile': 'AI billing',
  'channelOnboarding.registrationSummary.sections.defaultEnvironment': 'Default environment',
  'channelOnboarding.registrationSummary.fields.agreementId': 'Commercial agreement',
  'channelOnboarding.registrationSummary.fields.budgetEnabled': 'Budget enabled',
  'channelOnboarding.registrationSummary.fields.environmentType': 'Environment type',
  'channelOnboarding.registrationSummary.fields.isDefault': 'Default',
  'channelOnboarding.registrationSummary.fields.isPublic': 'Public',

  'channelOnboarding.progress.title': 'Registration progress',
  'channelOnboarding.step.inProgress': 'In progress',

  'channelOnboarding.errors.selectEntityTypeFirst': 'Select a registration type first.',
  'channelOnboarding.errors.duplicateIdentity': 'This identity is already in use.',
  'channelOnboarding.errors.planNotAllowedForActor':
    'The selected plan is not allowed for this actor type.',
};
